import { Box, Card, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import useWallet from '../../../../hooks/useWallet';
import useAuthUsers from '../../../../hooks/useAuthUsers';
import useWalletVerif from '../../../../hooks/useWalletVerif';
import WalletCard from './WalletCard';

function WalletView({ handleNavigate }) {
  const { currentUser } = useAuthUsers();
  const { walletExist, loadingWallet } = useWalletVerif(currentUser.id);
  const { createWallet } = useWallet();
  return (
    <Box>
      {loadingWallet && !walletExist && <CircularProgress />}
      {walletExist && !loadingWallet && <WalletCard handleNavigate={handleNavigate} />}
      {!walletExist && !loadingWallet && (
        <Card
          onClick={() => createWallet(currentUser.id)}
          sx={{ padding: '10px', cursor: 'pointer', marginTop: '10px', textAlign: 'center' }}
        >
          <Typography variant="subtitle1">Inicializa tu wallet</Typography>
          <Typography variant="subtitle2">(Haz click aquí)</Typography>
        </Card>
      )}
    </Box>
  );
}

export default WalletView;
